// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyCardFinderRequest {
    static getAttributeTypeMap() {
        return PharmacyCardFinderRequest.attributeTypeMap;
    }
}
PharmacyCardFinderRequest.discriminator = undefined;
PharmacyCardFinderRequest.additionalProperties = false;
PharmacyCardFinderRequest.attributeTypeMap = [
    {
        "name": "ndc",
        "baseName": "ndc",
        "type": "string"
    },
    {
        "name": "pharmacyNpi",
        "baseName": "pharmacyNpi",
        "type": "number"
    },
    {
        "name": "pharmacyNcpdpid",
        "baseName": "pharmacyNcpdpid",
        "type": "number"
    },
    {
        "name": "prescriber",
        "baseName": "prescriber",
        "type": "Prescriber"
    },
    {
        "name": "patient",
        "baseName": "patient",
        "type": "Patient"
    },
    {
        "name": "mock",
        "baseName": "mock",
        "type": "boolean"
    },
];
//# sourceMappingURL=pharmacyCardFinderRequest.js.map